// =============================================================================
// pages/admin/Canais.tsx — /admin/canais
//
// Wrapper canônico para a feature page de canais de mensagem.
// Segue padrão estabelecido em pages/admin/Agents.tsx.
// =============================================================================

import * as React from 'react';

import { CanaisPage } from '../../features/configuracoes/canais/CanaisPage';

export function CanaisAdminPage(): React.JSX.Element {
  return <CanaisPage />;
}
